import { Entity, System } from "ecsy";
import { BloodCell, Physics, Submerged } from "../components";
import { CollisionCategory } from "../constants";
import { getId } from "../entityFactory";
import { Game } from "../game";
import { clamp, seededRandom } from "../utils";

export class SubmergeSystem extends System {
	private game: Game;

	constructor(world: any, attributes: any) {
		// @ts-ignore
		super(world, attributes);
		this.game = attributes.game;
	}

	execute(delta: number) {
		const deltaSeconds = delta / 1000;
		this.queries.submerged.added?.forEach(entity => {
			const physics = entity.getComponent(Physics);
			if (physics) {
				const submerge = entity.getComponent(Submerged);
				const filter = physics.fixture.GetFilterData();
				submerge.savedMaskBits = filter.get_maskBits()
				filter.set_maskBits(submerge.collisionMask);
				physics.fixture.SetFilterData(filter);
			}
		});

		const resurface = new Array<Entity>();
		for (const entity of this.queries.submerged.results) {
			const submerge = entity.getComponent(Submerged);

			//get a consistent random number
			const id = getId(entity) || 43;
			let rand = seededRandom(id);
			if (rand < 0.01) rand = 0.05

			const direction = (submerge.surfacing ? -1 : 1);
			const increment = (deltaSeconds * (1 / submerge.rate)) + (rand * 0.006);
			const progress = submerge.percentSubmerged += direction * increment;
			submerge.percentSubmerged = clamp(progress, 0, submerge.max);
			if (submerge.surfacing && submerge.percentSubmerged == 0) {
				resurface.push(entity);
			}
		}
		resurface.forEach(entity => entity.removeComponent(Submerged));

		this.queries.submerged.removed?.forEach(entity => {
			const physics = entity.getComponent(Physics);
			if (physics) {
				const submerge = entity.getRemovedComponent(Submerged);
				const filter = physics.fixture.GetFilterData();
				filter.set_maskBits(submerge.savedMaskBits);
				physics.fixture.SetFilterData(filter);
				if (entity.hasComponent(BloodCell)) {
					console.log("Restoring collision on blood cell");
				}
			}
		});
	}
}


SubmergeSystem.queries = {
	submerged: { components: [Submerged], listen: { added: true, removed: true } },
}

